export const COUNTRIES_API_URL = 'https://restcountries.com/v2';

export const queryParams = {
	basic: 'name,capital,population,region,flag',
	extended: 'subregion,topLevelDomain,nativeName,currencies,languages',
};
